import { render, staticRenderFns } from "./grapes.vue?vue&type=template&id=1fa662fd"
import script from "./grapes.vue?vue&type=script&lang=js"
export * from "./grapes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports